import reducer from './reducers';

import * as financingTermsSelectors from './selectors';
import * as financingTermsOperations from './operations';
import * as financingTermsTypes from './types';

export { financingTermsSelectors, financingTermsOperations, financingTermsTypes };

export default reducer;
